module.exports = __webpack_public_path__ + "static/Crowns 1 intraoral after-ecc72bb4d81a6a331977b737f6262e31.jpg";